import React from 'react';
import { Badge, Box, Group, Text, Tooltip } from '@mantine/core';

// Renders the per-collection added/changed/removed counts from a generation pass so a refine reads as
// a visible diff. Empty patch → "no changes" (the design was already consistent with the sources).
export default function ChangeSummary({ summary }) {
  const { byCollection = {}, openQuestionsAdded = 0, conflicts = 0, conflictPaths = [] } = summary || {};
  const parts = [];
  for (const [collection, c] of Object.entries(byCollection)) {
    const bits = [];
    if (c.added) bits.push(`+${c.added}`);
    if (c.changed) bits.push(`~${c.changed}`);
    if (c.removed) bits.push(`-${c.removed}`);
    if (bits.length) parts.push(`${collection} ${bits.join(' ')}`);
  }
  return (
    <Box mt="xs">
      <Text size="xs" fw={600}>Revision summary</Text>
      {parts.length === 0 && openQuestionsAdded === 0 ? (
        <Text size="xs" c="dimmed">No changes — the design was already consistent with the current sources.</Text>
      ) : (
        <Group gap="xs" mt={4}>
          {parts.map((p) => <Badge key={p} size="xs" variant="light" color="orange">{p}</Badge>)}
          {openQuestionsAdded > 0 && <Badge size="xs" variant="light" color="yellow">+{openQuestionsAdded} open question(s)</Badge>}
          {conflicts > 0 && (
            // §4.3: name the human-locked field paths a regeneration tried (and failed) to overwrite,
            // not just a count — so the engineer sees exactly what was preserved.
            <Tooltip
              disabled={conflictPaths.length === 0}
              label={conflictPaths.join('\n')}
              withArrow multiline w={320} style={{ whiteSpace: 'pre-line' }}
            >
              <Badge size="xs" variant="light" color="grape" style={{ cursor: conflictPaths.length ? 'help' : 'default' }}>
                {conflicts} edit(s) preserved
              </Badge>
            </Tooltip>
          )}
        </Group>
      )}
    </Box>
  );
}
